const Module = () => import('./Module.vue')
const Home = () => import('./views/Home.vue')

const moduleRoute = {
  path: '/legal-portfolios',
  component: Module,
  children: [
    {
      path: '/',
      name: 'legal-portfolios',
      component: Home,
    },
  ],
}

export default router => {
  router.addRoutes([moduleRoute])
}
